import { ConfirmActionModal } from '@/components/commons/confirm-action-modal'
import { useUpdateStepToAiManualRetouchingUpload } from '@/features/photoset/queries/use-update-step-to-ai-manual-retouching-upload'
import type { PhotosetSpace } from '@/features/photoset/types'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS, queryClient } from '@/query-client'
import { useTranslation } from '@/translations/i18n'

export const AiVettingConfirmManualRetouchingModal = ({
	photosetId,
	needManualRetouchingImages,
	onClose
}: {
	photosetId: number
	needManualRetouchingImages: PhotosetSpace['images']
	onClose: () => void
}) => {
	const { t } = useTranslation()
	const updateStepToAiManualRetouchingMutation =
		useUpdateStepToAiManualRetouchingUpload({
			onError: (error) => errorHandler(error),
			onSuccess: () => {
				queryClient.invalidateQueries({
					queryKey: [QUERY_KEYS.PHOTOSET]
				})
				queryClient.invalidateQueries({
					queryKey: [QUERY_KEYS.PHOTOSET_SPACES]
				})
				queryClient.invalidateQueries({
					queryKey: [QUERY_KEYS.MANUAL_RETOUCHING_SPACES]
				})
			}
		})

	return (
		<ConfirmActionModal
			headerTitle=''
			isLoading={updateStepToAiManualRetouchingMutation.isPending}
			onClose={onClose}
			onConfirm={() =>
				updateStepToAiManualRetouchingMutation.mutate(photosetId)
			}
			paragraph={t('photoset:ai_vetting.modal.subtitle')}
			title={t('photoset:ai_vetting.modal.title', {
				count: needManualRetouchingImages.length
			})}
		/>
	)
}
